import { Box, Grid, MenuItem, Select, Typography } from "@mui/material";
import Group1FileForm from "./Group1FileForm";

const CsvCustomerGroupSelect = ({groups, value, onSelect, ...props}) => {

  const handleChangeGroup = (_e, groupId) => {
    onSelect(groupId);
  } 

  return (
    <Select
      onChange={handleChangeGroup}
      value={value ? value.toString() : ""}
      {...props}
    >
      {
        groups.map((group) => (
          <MenuItem
            key={`menuItem-${group.csvCustomerGroupId.toString()}`}
            value={group.csvCustomerGroupId.toString()}
          >
            {group.groupName}
          </MenuItem>
        ))
      }
    </Select>
  );
}

export default function CsvFileForm ({csvForm, onSubmit, onChange}) {

  const csvCustomerGroups = [{csvCustomerGroupId: 1, groupName:'ニシザワ'}];

  const selectedGroupId = csvForm.csvCustomerGroupId; /** 現時点でCSV取引先グループが1つしかないので暫定的にgroupId: 1とする **/

  const handleSubmit = (files) => {
    onSubmit(files);
  }

  const handleChange = (
    changeFunc, onSucceededChange = () => {}, onFailedChange = () => {}
  ) => {
    onChange(changeFunc, onSucceededChange, onFailedChange);
  }

  return (
    <Box>
      <Grid container
        spacing={2}
        alignItems='center'
      >
        <Grid item>
          <Typography
            sx={{fontSize: 20, fontWeight: 'bold'}}
          >
            CSVファイル選択
          </Typography>
        </Grid>
        <Grid item>
          取引先: 
          <CsvCustomerGroupSelect
            groups={csvCustomerGroups}
            value={selectedGroupId}
            readOnly  /** 現時点でCSV取引先グループが1つしかないので暫定的に変更不可とする **/
          />
        </Grid>        
      </Grid> 
      <Box mt={1} padding={2} border='1px grey solid' borderRadius={2}>
        <Group1FileForm
          onChange={handleChange}
          onSubmitForm={handleSubmit}
          csvForm={csvForm}
        />
      </Box>
    </Box>    


  );
}